var React = require('react');

function Down (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22","cy":"22","r":"20.5","stroke":"black","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M23.4516 10L23.4516 28.5189L30 21.9351L32 23.9135L21.9677 34L12 23.9135L14 21.9351L20.5484 28.5514L20.5484 10L23.4516 10Z","fill":"black","key":1})]);
}

Down.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Down;

Down.default = Down;
